const blockchainConfig = {
    networkName: "Rails Testnet",
    rpcUrl: "https://mainnet.steamexchange.io",
    chainId: 6274,
    contractAddress: "0x388603B9D3715E51ee9d1c6300bFB289b8fC4736",
    explorerUrl: "https://explore.steamexchange.io",
  };
  
  export default blockchainConfig;
  